import React from 'react';

export const PROGRAMS = ['CCM', 'RPM', 'PCM', 'APCM'];
export const selectedPrograms = (patientType, isCCM) => {
    const selected = patientType === 'Both' ? ['CCM', 'RPM'] : [patientType || 'RPM'];
    if (isCCM && !selected.includes('CCM')) selected.push('CCM');
    return selected;
};

export const toProgramForm = (rows = []) => Object.fromEntries(rows.map((row) => [row.program, {
    startDate: row.startDate ? String(row.startDate).slice(0, 10) : '',
    consentGiven: row.consentGiven === true ? 'yes' : row.consentGiven === false ? 'no' : '',
    consentDate: row.consentDate ? String(row.consentDate).slice(0, 10) : '',
    consentMethod: row.consentMethod || '',
    consentRecordedBy: row.consentRecordedBy || '',
    consentRecordedAt: row.consentRecordedAt || '',
    consentStatus: row.consentStatus || '',
}]));

const ProgramEnrollmentFields = ({ programs, values, onChange, requiredPrograms = [] }) => {
    const today = new Date().toISOString().slice(0, 10);
    return programs.map((program) => {
        const row = values[program] || {};
        const required = requiredPrograms.includes(program);
        const change = (field) => (e) => onChange(program, field, e.target.value);
        return (
            <fieldset className="col-md-12 mt-3 p-3" key={program} style={{ border: '1px solid #ddd' }}>
                <legend style={{ fontSize: 16 }}>{program} enrollment {required ? '*' : ''}</legend>
                {!row.consentGiven && <div className="text-muted">{row.consentStatus === 'to_verify' ? 'Consent: verify at next contact' : 'Consent not recorded'}</div>}
                <div className="row">
                    <label className="col-md-6">Program start date
                        <input className="form-control" type="date" max={today} value={row.startDate || ''} required={required} onChange={change('startDate')} />
                    </label>
                    <label className="col-md-6">Patient consent
                        <select className="form-control" value={row.consentGiven || ''} required={required} onChange={change('consentGiven')}>
                            <option value="">Consent not recorded</option><option value="yes">Yes</option><option value="no">No</option>
                        </select>
                    </label>
                    {row.consentGiven === 'yes' && <>
                        <label className="col-md-6 mt-2">Consent date
                            <input className="form-control" type="date" max={today} value={row.consentDate || ''} required onChange={change('consentDate')} />
                        </label>
                        <label className="col-md-6 mt-2">Consent method
                            <select className="form-control" value={row.consentMethod || ''} required onChange={change('consentMethod')}>
                                <option value="">Select</option><option value="verbal">Verbal</option><option value="written">Written</option>
                            </select>
                        </label>
                    </>}
                </div>
                {row.consentRecordedBy && <small className="text-muted">Recorded by {row.consentRecordedBy} at {row.consentRecordedAt}</small>}
            </fieldset>
        );
    });
};

export default ProgramEnrollmentFields;
